/** @format */

import { CardMedia, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ImageContainer = styled("div")(({ theme }) => ({
	position: "relative",
	width: "100%",
	height: "90vh",
	marginTop: 30,
	marginBottom: 120,

	[theme.breakpoints.down("md")]: {
		// Adjustments for medium screens
		height: "55vh",
		marginTop: 60,
		marginBottom: 80,
	},
	[theme.breakpoints.down("sm")]: {
		// Adjustments for small screens
		height: "55vh",
		marginTop: 40,
		marginBottom: 600,
	},
}));

type StyledCardMediaProps = React.ComponentProps<typeof CardMedia> & {
	component?: string;
	alt?: string;
};

export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>(
	({ theme }: { theme: Theme }) => ({
		[theme.breakpoints.down("md")]: {
			height: "50vh",
			borderRadius: "2px",
			width: "100%",
		},
		[theme.breakpoints.down("sm")]: {
			height: "65vh",
			borderRadius: "2px",
			width: "100%",
			marginTop: "0",
		},
	})
);

export const BaseImage = styled(CardMedia)(({ theme }) => ({
	position: "absolute",
	zIndex: 1,
	width: "100%",
	height: "auto",
	top: 0,
	left: "25%",
	transform: "translateX(-50%)", // Center horizontally

	[theme.breakpoints.down("md")]: {
		top: "1%",
		left: "50%",
		transform: "translateX(-50%)",
		marginBottom: "25px",
		zIndex: 1,
	},
	[theme.breakpoints.down("sm")]: {
		top: "0",
		left: "50%",
		transform: "translateX(-50%)",
		zIndex: 2,
	},
}));

// Define the second image component with styled-components
export const OverlapImage = styled(CardMedia)(({ theme }) => ({
	position: "absolute",
	zIndex: 2,
	width: "90%",
	height: "auto",
	top: "15%",
	left: "79%",
	transform: "translateX(-50%)",

	[theme.breakpoints.down("md")]: {
		top: "91%",
		left: "50%",
		width: "100%",
		transform: "translateX(-50%)",
		position: "relative",
		zIndex: 1,
		marginTop: "25px",
	},
	[theme.breakpoints.down("sm")]: {
		top: "110%",
		width: "100%",
		zIndex: 1,
		left: "initial",
		transform: "initial",
		marginTop: "56.25%",
	},
}));
